import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ROUTE} from "../../../home-layout/common/constant/routing.constant";
import {
    LibSnackBarConfig,
    SNACK_BAR_TYPE
} from "../../../../tal-library/snackbar/lib-snackbar/common/model/lib-snackbar.model";
import {LibSnackbarService} from "../../../../tal-library/snackbar/lib-snackbar/common/service/lib-snackbar.service";
import {LoginOutDto} from "../../../home-layout/common/model/user.model";
import {TokenUtil} from "../util/token.util";

@Injectable({
    providedIn: 'root'
})
export class TokenService {

    private redirectUrl: string;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private libSnackbarService: LibSnackbarService) {
    }

    handleLoginSuccess(loginOutDto: LoginOutDto) {
        this.setRedirectUrlIfExists();
        this.processAccessToken(loginOutDto);
        this.checkAndNavigate();
        this.showSnackBar();
    }

    handle403(): void {
        // TODO : handle it in interceptor
        const token = localStorage.getItem(ROUTE.TOKEN);
        if (TokenUtil.isTokenExpired(token)) {
            this.tokenExpired();
        }
    }

    handle401(): void {
        const token = localStorage.getItem(ROUTE.TOKEN);
        const decodedToken = TokenUtil.decodeToken(token);
        if (TokenUtil.isTokenExpired(token)) {
            this.tokenExpired();
        } else if (decodedToken?.userMinOutDto?.username == null) {
            this.handleTokenOlderFormat();
        }
    }

    private handleTokenOlderFormat(): void {
        this.libSnackbarService.openSnackBar(new LibSnackBarConfig('Oops! Please login.',
            SNACK_BAR_TYPE.DANGER));
        this.logout();
    }

    setAccessToken(accessToken: string): void {
        if (accessToken) {
            const token = 'Bearer ' + accessToken;
            this.saveToken(ROUTE.TOKEN, token);
        }
    }

    private setRedirectUrlIfExists(): void {
        this.activatedRoute.queryParamMap.subscribe(queryParamMap => {
            const redirectUrl = queryParamMap.get(ROUTE.REDIRECT_URL);
            if (redirectUrl) {
                this.redirectUrl = redirectUrl;
            }
        });
    }

    private processAccessToken(loginOutDto: LoginOutDto): void {
        const token = loginOutDto?.jwtTokenDto?.accessToken;
        this.saveToken(ROUTE.TOKEN, token);
    }

    private checkAndNavigate(): void {
        this.redirectUrl
            ? this.router.navigate([this.redirectUrl.split('?')[0]])
            : this.navigateToDashboard();
    }

    private showSnackBar(): void {
        setTimeout(() => {
            this.libSnackbarService.openSnackBar(new LibSnackBarConfig('Welcome back', SNACK_BAR_TYPE.WELCOME));
        }, 1500);
    }

    private tokenExpired(): void {
        this.libSnackbarService.openSnackBar(new LibSnackBarConfig('Oops! Your login token is expired. Please login.',
            SNACK_BAR_TYPE.DANGER));
        this.logout();
    }

    private navigateToDashboard(): void {
        this.router.navigate([ROUTE.DASHBOARD]);
    }

    private logout(): void {
        this.clearLocalStorageItems();
        this.redirectToLogin();
    }

    private clearLocalStorageItems(): void {
        localStorage.removeItem(ROUTE.TOKEN);
        localStorage.removeItem(ROUTE.ORGANIZATION_ID);
        localStorage.clear();
    }

    private saveToken(tokenKey: string, tokenValue: string): void {
        localStorage.setItem(tokenKey, tokenValue);
    }

    private redirectToLogin() {
        this.router.navigate([ROUTE.AUTH, ROUTE.LOGIN]).then(() => {
            window.location.reload();
        });
    }
}
